module.exports = __webpack_public_path__ + "img/Number=7.24d3b173.png";